import React from "react";
import {
  Typography,
  Grid,
} from "@material-ui/core";
import { IMAGES_ENDPOINT } from "@icarius-connection/endpoints";
import { previewFromURL } from "@icarius-utils/download";
import { getLocalizedString } from "@icarius-localization/strings";
import OnaQuestion from "./questionTypes/onaQuestion";
import NpsRadioQuestion from "./questionTypes/npsRadioQuestion";
import RadioQuestion from "./questionTypes/radioQuestion";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const Question = (props) => {

  const {
    type,
    options,
    title,
    error,
    image,
    isNPS,
    isONA,
    colaboratorList,
    isCompleted,
    onChange,
    value,
  } = props;

  const renderQuestion = () => {
    if (isNPS && type === 'radio') {
      return (
        <NpsRadioQuestion
          options={options}
          isCompleted={isCompleted}
          onChange={onChange}
          value={value}
        />
      );
    }

    if (isONA) {
      return (
        <OnaQuestion
          options={options}
          colaboratorList={colaboratorList}
          isCompleted={isCompleted}
          onChange={onChange}
          value={value}
        />
      );
    }

    if (type === 'radio') {
      return (
        <RadioQuestion
          options={options}
          isCompleted={isCompleted}
          onChange={onChange}
          value={value}
        />
      );
    };

    if (type === 'text') {
      return (
        <TextFieldMultiline
          style={{ marginTop: 10 }}
          disabled={isCompleted}
          value={value}
          onChange={(e) => onChange(e.target.value.toString().slice(0, 254))}
          onInput={(e) => e.target.value = e.target.value.toString().slice(0, 254)}
          rows={3}
          rowsMax={6}
          fullWidth
          margin={"none"}
        />
      )
    };

    return null;
  }

  return (
    <section>
      <Typography variant={"h6"} className={"label whiteText"}>
        {title}
      </Typography>
      <Grid container item xs={12}>
        {renderQuestion()}
      </Grid>
      {
        Boolean(image) &&
        <>
          <div style={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
            <img
              style={{ maxWidth: '60%', cursor: 'pointer' }}
              src={IMAGES_ENDPOINT + image}
              alt={"imageNotFound"}
              onClick={() => previewFromURL(IMAGES_ENDPOINT + image)}
            />
          </div>
          <Typography variant={"caption"} align="center" style={{ display: 'block' }}>
            {getLocalizedString("clickImageToEnlarge")}
          </Typography>
        </>
      }
      {
        Boolean(error) &&
        <Typography style={{ maxWidth: "unset" }} variant={"subtitle1"} className={"error-text"}>
          {error}
        </Typography>
      }
    </section>
  );
}

export default Question;